"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose3 = exports.sha256Hash = void 0;

var sha_js_1 = __importDefault(require("sha.js"));

var sha256Hash = function sha256Hash(data) {
  return sha_js_1.default('sha256').update(data).digest();
};

exports.sha256Hash = sha256Hash;

var compose3 = function compose3(f, g, h) {
  return function (x) {
    return f(g(h(x)));
  };
};

exports.compose3 = compose3;